import styled from 'styled-components';

export const ArticleFields = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
`;

/** Article name + slug on one row (stacked on narrow widths). */
export const ArticleTitleSlugFields = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;

    .article-slug-control-wrap {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        min-width: 0;
    }

    .article-slug-control-wrap .ant-input {
        flex: 1 1 auto;
        min-width: 0;
    }

    .article-slug-control-wrap.slug-readonly .ant-input {
        opacity: 0.4;
    }

    @media (max-width: 560px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

/** Author + date row below name/slug (two columns, stacked on narrow widths). */
export const ArticleMetaFields = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;

    .article-meta-control-wrap {
        width: 100%;
        min-width: 0;
    }

    .article-meta-control-wrap .ant-select {
        width: 100% !important;
    }

    .article-meta-date-picker-wrap > div {
        margin: 0;
        width: auto;
    }

    .article-meta-date-picker-wrap .ant-picker {
        width: auto;
    }

    @media (max-width: 560px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const ArticleContentHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 2rem;
    margin-bottom: 0.5rem;
`;

export const ArticleContentLabel = styled.span`
    font-size: 0.85rem;
    font-weight: 400;
    color: ${(props) => props.theme.TextColorMuted};
    text-transform: uppercase;
`;

export const ArticleRowAddToolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

/** Scrollable edit body: leaves space for fixed save/cancel bar. */
export const ArticleEditorEditBodyWrap = styled.div`
    padding-bottom: 5.75rem;
`;

export const ArticleSaveActions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.35rem;

    .article-save-error {
        color: ${(props) => props.theme.DangerColor};
        font-size: 0.75rem;
        line-height: 1.25;
        text-align: right;
        text-transform: uppercase;
    }
`;

/** Empty content state when article has no rows yet. */
export const ArticleContentEmptyRowsBox = styled.div`
    border: ${(props) => props.theme.DefaultBorder};
    background: #fafafa;
    border-radius: 6px;
    padding: 1.5rem 1.25rem 1.35rem;
    text-align: center;

    .empty-rows-hint {
        margin: 0.85rem auto 0;
        max-width: 22rem;
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.TextColorMuted};
        line-height: 1.45;
    }
`;

/** Toolbar dopo l’ultima riga (stesso layout di ArticleRowAddToolbar) */
export const ArticleRowAddToolbarBelow = styled(ArticleRowAddToolbar)`
    margin-top: 0.5rem;
`;

export const ArticleRowsList = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 1rem;
`;

/** Body of the unsaved-changes modal: icon + message side-by-side. */
export const UnsavedChangesMessage = styled.div`
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 0.5rem 0.25rem 1rem 0.25rem;

    .danger-icon {
        color: ${(props) => props.theme.WarningColor};
        flex: 0 0 auto;
    }

    .unsaved-changes-text {
        margin: 0;
        font-size: 1.05rem;
        line-height: 1.4;
        color: ${(props) => props.theme.TextColor};
    }

    .unsaved-changes-hint {
        margin: 0.4rem 0 0 0;
        font-size: 0.9rem;
        color: ${(props) => props.theme.TextColorMuted};
    }
`;

export const UnsavedChangesFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;

    .unsaved-changes-footer-right {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        flex-wrap: wrap;
    }
`;
